function formatRequestedAt(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-PK', {
    timeZone: 'Asia/Karachi',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }) + ' PKT';
}

export function requestedRegradeTitle(request) {
  const slot = request && request.slot;
  const when = formatRequestedAt(request && request.created_at);
  const open = `Open Check with the students, questions, and voice note from Re-Grade ${slot}`;
  return when ? `Requested ${when}. ${open}` : open;
}

export const REGRADE_CLEARED_EVENT = 'fastgrader:regrade-cleared';

export function rubricIdFromFolderPath(folderPath) {
  const match = String(folderPath || '').match(/rubrics\/(\d+)/);
  return match ? match[1] : '';
}

export function dropClearedRegrade(reviews, folderId, slot) {
  const prev = reviews || { verified: {}, requests: {} };
  const key = String(folderId);
  const list = (prev.requests && prev.requests[key]) || [];
  return {
    ...prev,
    requests: {
      ...(prev.requests || {}),
      [key]: list.filter((row) => Number(row.slot) !== Number(slot))
    }
  };
}

export async function deleteRegradeRequest(folderPath, slot) {
  const folderId = rubricIdFromFolderPath(folderPath);
  if (!folderId || slot == null || slot === '') {
    throw new Error('This re-grade is not tied to a folder');
  }
  const token = localStorage.getItem('authToken');
  const res = await fetch(`${window.API_BASE_URL}/analyze/folders/${folderId}/regrade-requests/${slot}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!res.ok && res.status !== 404) {
    const data = await res.json().catch(() => ({}));
    throw new Error((data && data.message) || 'Could not remove this re-grade');
  }
  window.dispatchEvent(new CustomEvent(REGRADE_CLEARED_EVENT, {
    detail: { folderId, slot: Number(slot) }
  }));
}
